// src/features/rrhh/mensajeria/api/mensajesApi.js
import httpClient from "../../../../shared/api/httpClient";
import { qs } from "../../../../shared/api/qs";

function getLicenseIdOrThrow() {
  try {
    const v = localStorage.getItem("sabi_empresa_id");
    if (!v) throw new Error();
    const n = Number(v);
    if (!Number.isFinite(n) || n <= 0) throw new Error();
    return n;
  } catch {
    throw new Error("No se encontró sabi_empresa_id en localStorage (license requerida).");
  }
}

export const listarSucursales = () => {
  const licenseId = getLicenseIdOrThrow();
  return httpClient.get(`/admin/licenses/${licenseId}/branches`);
};

/**
 * MENSAJES GENERALES (WEB)
 * GET /hr/areas/messaging/licenses/:licenseId/messages
 */
export const listarMensajes = (filters = {}) => {
  const licenseId = getLicenseIdOrThrow();

  const query = qs({
    branchId: filters.branchId ?? filters.sucursal_id,
    scope: filters.scope ?? filters.alcance,
    topic: filters.topic ?? filters.tema,
    q: filters.q,
    limit: filters.limit ?? 50,
    offset: filters.offset ?? 0,
  });

  return httpClient.get(
    `/hr/areas/messaging/licenses/${licenseId}/messages${query}`
  );
};

/**
 * POST /hr/areas/messaging/licenses/:licenseId/messages
 */
export const crearMensaje = (data) => {
  if (!data) throw new Error("data es requerido");

  const licenseId = getLicenseIdOrThrow();

  const payload = {
    scope: data.scope ?? data.alcance,
    branchId:
      data.branchId !== undefined
        ? data.branchId
        : data.id_sucursal !== undefined
        ? data.id_sucursal
        : null,
    eventId:
      data.eventId !== undefined
        ? data.eventId
        : data.id_evento !== undefined
        ? data.id_evento
        : null,
    topic: data.topic ?? data.tema,
    title: data.title ?? data.titulo,
    content: data.content ?? data.contenido,
    isActive:
      data.isActive !== undefined
        ? data.isActive
        : data.activo !== undefined
        ? data.activo
        : true,
  };

  return httpClient.post(
    `/hr/areas/messaging/licenses/${licenseId}/messages`,
    payload
  );
};

export const actualizarMensaje = (messageId, data) => {
  if (!messageId) throw new Error("messageId es requerido");
  if (!data) throw new Error("data es requerido");

  const licenseId = getLicenseIdOrThrow();

  const payload = {
    scope: data.scope ?? data.alcance,
    branchId:
      data.branchId !== undefined
        ? data.branchId
        : data.id_sucursal !== undefined
        ? data.id_sucursal
        : undefined,
    eventId:
      data.eventId !== undefined
        ? data.eventId
        : data.id_evento !== undefined
        ? data.id_evento
        : undefined,
    topic: data.topic ?? data.tema,
    title: data.title ?? data.titulo,
    content: data.content ?? data.contenido,
    isActive:
      data.isActive !== undefined
        ? data.isActive
        : data.activo !== undefined
        ? data.activo
        : undefined,
  };

  return httpClient.patch(
    `/hr/areas/messaging/licenses/${licenseId}/messages/${messageId}`,
    payload
  );
};

export const eliminarMensaje = (messageId) => {
  if (!messageId) throw new Error("messageId es requerido");

  const licenseId = getLicenseIdOrThrow();
  return httpClient.delete(
    `/hr/areas/messaging/licenses/${licenseId}/messages/${messageId}`
  );
};